(function () {
  const MULTIPLIER = 1.2;                 // price uplift for display
  const MAX_DROPDOWNS = 5;                // cap displayed dropdowns
  const SHOP_ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  const LOG = true;

  const log = (...a) => { if (LOG) console.log('[UPS]', ...a); };

  // ----- money + formatting helpers -----------------------------------------
  const moneyFromPence = (p) => `£${(p / 100).toFixed(2)}`;
  const multipliedFloor = (p) => Math.floor(p * MULTIPLIER);

  // Proper strike-through for whole strings inside <option> (no HTML allowed)
  const strike = (txt) => Array.from(String(txt)).map(ch => ch + '\u0336').join('');

  // NEW: If compare_at exists and is higher, just add " - ON SALE" (no compare shown)
  const formatWithCompare = (cur, comp) => {
    const up = moneyFromPence(multipliedFloor(cur));
    if (comp && comp > cur) {
      return `(+${up}) - ON SALE`;
    }
    return `(+${up})`;
  };

  // rules + product data ------------------------------------------------------
  const rulesScript = () => document.querySelector('#upsell-rules-data');
  const getRules = () => {
    const s = rulesScript();
    if (!s) return [];
    try { const d = JSON.parse(s.textContent || '{}'); return Array.isArray(d.rules) ? d.rules : []; } catch { return []; }
  };
  const getCurrentProductHandle = () => {
    const s = rulesScript();
    return s ? s.getAttribute('data-for-product') : null;
  };
  const fetchProduct = async (handle) => {
    const r = await fetch(`/products/${handle}.js`);
    if (!r.ok) throw new Error('fetch failed');
    return await r.json();
  };

  // label templating
  const applyLabelTemplate = (tpl, title) =>
    String(tpl || '')
      .replace(/\[\[\s*upsell_title\s*\]\]/g, title)
      .replace(/{{\s*upsell_title\s*}}/g, title);

  // --- tolerant parser for "Allowed variant IDs" (CSV, spaces, new lines, URLs)
  function parseVariantIdsCsv(raw) {
    if (!raw) return null;
    const matches = String(raw).match(/\d{6,}/g);
    if (!matches || !matches.length) return new Set();
    return new Set(matches.map(id => String(id)));
  }

  // build a single upsell dropdown (no “don’t add” option)
  function buildDropdown(rule, productJson, index) {
    const wrap = document.createElement('div');
    wrap.className = 'upsell-item';
    wrap.setAttribute('data-upsell-handle', rule.upsell_handle);

    const label = document.createElement('label');
    label.className = 'upsell-label';
    label.setAttribute('for', `upsell-select-${index}`);
    label.textContent = applyLabelTemplate(rule.custom_label || 'Add [[upsell_title]] to your basket', productJson.title);

    const select = document.createElement('select');
    select.id = `upsell-select-${index}`;
    select.className = 'upsell-select';

    // Disabled, selected placeholder (user must pick a real variant)
    const placeholder = (rule.placeholder_text || 'SELECT OPTION').trim();
    const optPlaceholder = document.createElement('option');
    optPlaceholder.value = '';
    optPlaceholder.textContent = placeholder;
    optPlaceholder.disabled = true;
    optPlaceholder.selected = true;
    select.appendChild(optPlaceholder);

    // Optional allow-list of variants
    let allowed = null;
    if (rule.all_variants !== true && rule.allowed_variant_ids_csv && rule.allowed_variant_ids_csv.trim().length) {
      allowed = parseVariantIdsCsv(rule.allowed_variant_ids_csv);
    }

    // Helpers
    const isDefaultTitle = (t) => /^default\s+title$/i.test(String(t || '').trim());
    const ensureAddPrefix = (t) => (/^add\b/i.test(t) ? t : `Add ${t}`);

    productJson.variants.forEach(v => {
      if (allowed && allowed.size && !allowed.has(String(v.id))) return;

      const opt = document.createElement('option');
      opt.value = String(v.id);

      const baseName = isDefaultTitle(v.title) ? productJson.title : v.title;
      const variantName = ensureAddPrefix(baseName);
      const pretty = formatWithCompare(v.price, v.compare_at_price);
      const full = `${variantName} ${pretty}`;

      if (!v.available) {
        opt.textContent = `${strike(full)} (Unavailable)`;
        opt.disabled = true;
      } else {
        opt.textContent = full;
      }

      select.appendChild(opt);
    });

    // Placeholder style while no value picked
    function updatePlaceholderClass() { select.classList.toggle('is-placeholder', !select.value); }
    select.addEventListener('change', updatePlaceholderClass);
    updatePlaceholderClass();

    wrap.appendChild(label);
    wrap.appendChild(select);
    return wrap;
  }

  // resolve main variant id (robust)
  function findMainVariantId(productJson, form) {
    const fromUrl = new URLSearchParams(window.location.search).get('variant');
    if (fromUrl) return String(fromUrl);

    const idEl = form && (form.querySelector('input[name="id"]') || form.querySelector('select[name="id"]'));
    if (idEl && idEl.value) return String(idEl.value);

    if (productJson && productJson.options && productJson.options.length && form) {
      const chosen = [];
      productJson.options.forEach((optName, idx) => {
        let val = '';
        const sel = form.querySelector(`select[name="options[${CSS.escape(optName)}]"]`);
        if (sel) val = sel.value;
        if (!val) {
          const r = form.querySelector(`input[type="radio"][name="options[${CSS.escape(optName)}]"]:checked`);
          if (r) val = r.value;
        }
        chosen[idx] = val;
      });
      if (chosen.filter(Boolean).length) {
        const v = productJson.variants.find(v => Array.isArray(v.options) && v.options.length === chosen.length && v.options.every((o, i) => String(o) === String(chosen[i])));
        if (v) return String(v.id);
      }
    }

    if (productJson && productJson.variants && productJson.variants.length) {
      const avail = productJson.variants.find(v => v.available) || productJson.variants[0];
      if (avail) return String(avail.id);
    }
    return null;
  }

  // read selected upsells (only real variants — placeholder has empty value)
  function getSelectedUpsellIds() {
    return Array.from(document.querySelectorAll('#upsell-dropdowns .upsell-select'))
      .map(s => s.value)
      .filter(Boolean);
  }

  // combined items payload
  function buildItems(productJson, form) {
    const upsellIds = getSelectedUpsellIds();
    if (!upsellIds.length) { log('No upsells selected'); return null; }

    const mainId = findMainVariantId(productJson, form);
    const qty = (() => {
      if (!form) return 1;
      const fd = new FormData(form);
      const q = parseInt(fd.get('quantity') || '1', 10);
      return isNaN(q) ? 1 : q;
    })();

    if (!mainId) { log('No main variant id'); return null; }

    const items = [{ id: Number(mainId), quantity: qty }, ...upsellIds.map(id => ({ id: Number(id), quantity: 1 }))];
    log('Items prepared:', items);
    return items;
  }

  async function addCombined(items) {
    const res = await fetch(`${SHOP_ROOT}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items })
    });
    if (!res.ok) throw new Error(`AJAX add failed: ${res.status}`);
    return await res.json();
  }

  // mount UI (dropdowns) + grouping
  async function mountUI() {
    const root = document.querySelector('#upsell-dropdowns[data-upsell-scope="true"], #upsell-dropdowns[data-upsell-scope]');
    if (!root || root.__upsellMounted) return;
    root.__upsellMounted = true;

    const rules = getRules().slice(0, MAX_DROPDOWNS);
    log('Rules found:', rules.length);
    if (!rules.length) return;

    const grid = root.querySelector('.upsell__grid, .upsell-grid');
    const nodes = [];
    for (let i = 0; i < rules.length; i++) {
      const r = rules[i];
      try {
        const pjson = await fetchProduct(r.upsell_handle);
        const dd = buildDropdown(r, pjson, i + 1);
        nodes.push(dd);
        grid.appendChild(dd);
      } catch (e) { log('Failed to load upsell product', r.upsell_handle, e); }
    }

    if (!nodes.length) return;

    if (nodes.length > 1) {
      // Grouped mode: wrap all dropdowns into a single parent card
      const group = document.createElement('div');
      group.className = 'upsell-group';

      nodes.forEach(card => {
        const sub = document.createElement('div');
        sub.className = 'upsell-subitem';
        const label = card.querySelector('.upsell-label');
        const select = card.querySelector('.upsell-select');
        if (label) sub.appendChild(label);
        if (select) sub.appendChild(select);
        group.appendChild(sub);
        card.remove();
      });

      grid.appendChild(group);
    }

    root.hidden = false;
  }

  // global, delegated handlers (intercept add to cart)
  async function ensureHandler() {
    if (ensureHandler._ready) return;
    ensureHandler._ready = true;

    let productJson = null;
    try {
      const handle = getCurrentProductHandle();
      if (handle && handle !== 'not-product') {
        productJson = await fetchProduct(handle);
        log('Loaded product JSON for', handle);
      }
    } catch (e) { log('Could not load product JSON', e); }

    function nearestCartForm(startEl) {
      return startEl ? startEl.closest('form[action*="/cart/add"]') : document.querySelector('form[action*="/cart/add"]');
    }

    async function attemptIntercept(e, from = 'unknown') {
      const form = nearestCartForm(e ? e.target : null);
      const items = buildItems(productJson, form);
      if (!items) return; // let theme handle if no upsells chosen

      if (e) {
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
      }
      log(`Intercepted via ${from}; adding combined items…`);

      try { await addCombined(items); } catch {}
      window.location.href = `${SHOP_ROOT}cart`;
    }

    document.addEventListener('submit', function (e) {
      const form = e.target;
      if (!(form && form.matches('form[action*="/cart/add"]'))) return;
      attemptIntercept(e, 'form submit');
    }, { capture: true });

    document.addEventListener('click', function (e) {
      const el = e.target.closest('button, input, a, div, span');
      if (!el) return;
      if (el.classList && el.classList.contains('sp-validate-overlay')) {
        attemptIntercept(e, 'overlay click'); return;
      }
      if (el.matches('button[type="submit"], input[type="submit"], button[name="add"], input[name="add"], .product-form__submit')) {
        attemptIntercept(e, 'button click');
      }
    }, { capture: true });

    document.addEventListener('pointerdown', function (e) {
      const el = e.target.closest('.sp-validate-overlay');
      if (el) attemptIntercept(e, 'overlay pointerdown');
    }, { capture: true });

    log('Global interceptors attached');
  }

  // boot
  document.addEventListener('DOMContentLoaded', async () => {
    await mountUI();
    await ensureHandler();
  });
  document.addEventListener('shopify:section:load', async () => {
    await mountUI();
    await ensureHandler();
  });
  document.addEventListener('shopify:section:reorder', async () => {
    await mountUI();
    await ensureHandler();
  });
})();
